.gridContainer {
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 100%;
}
